import { http } from 'app/adapters/http/axios';
import { User } from './models/User';

export class MyUserService {
  /**
   * This API returns the details of the currently logged in User.
   * @returns User Successful operation.
   * @throws AxiosError
   */
  public static async getMyUser() {
    const result = await http.get<User>('/api/v2/myUser', {
      withCredentials: true,
    });
    return result;
  }

  /**
   * Abort current request
   */
  public static abortRequest() {
    http.abortRequest();
  }
}
